@for (traveller of travellers; track traveller; let i = $index) {
<span class="Traveller">
  @if (i < 2) {
  <div>{{traveller.forename}}, {{traveller.surname}}</div>
  }
</span>
}
<ng-template #tipContent>
  @for (traveller of travellers; track traveller; let i = $index) {
  <span>
    @if (i >= 2) {
    <div>{{traveller.forename}}, {{traveller.surname}}&nbsp;</div>
    }
  </span>
  }
</ng-template>
@if (travellers?.length > 2) {
<section (mouseleave)="tt2.close()" class="container">
  <span
    class="Traveller additionalTravellers"
    container="body"
    [ngbTooltip]="tipContent"
    triggers="manual"
    #tt2="ngbTooltip"
    (mouseenter)="tt2.open()"
    (focus)="tt2.open()"
    (blur)="tt2.close()"
    tabindex="0"
  >
    + {{travellers.length - 2}}</span
  >
</section>
}
